import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import translationEN from 'locales/en.json'
import translationSV from 'locales/sv.json'

export default function i18nInit(language) {
  return i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources: {
        en: { translation: translationEN },
        sv: { translation: translationSV },
      },
      lng: language,
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
    })
}
